// Generated by purs version 0.15.10
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Control_Monad_Rec_Class from "../Control.Monad.Rec.Class/index.js";
import * as Control_Promise from "../Control.Promise/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Filterable from "../Data.Filterable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Function_Uncurried from "../Data.Function.Uncurried/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_AVar from "../Effect.AVar/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Aff_AVar from "../Effect.Aff.AVar/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Uncurried from "../Effect.Uncurried/index.js";
import * as FRP_Event from "../FRP.Event/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Fusion_Data_ObservableEvent from "../Fusion.Data.ObservableEvent/index.js";
import * as Fusion_Generator from "../Fusion.Generator/index.js";
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Effect_Aff.bindAff);
var $$try = /* #__PURE__ */ Control_Monad_Error_Class["try"](Effect_Aff.monadErrorAff);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect_Aff.applicativeAff);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Effect_Aff.monadEffectAff);
var filterMap = /* #__PURE__ */ Data_Filterable.filterMap(/* #__PURE__ */ FRP_Event.filterableEvent(Effect.applicativeEffect));
var catchError1 = /* #__PURE__ */ Control_Monad_Error_Class.catchError(Effect_Aff.monadErrorAff);
var map1 = /* #__PURE__ */ Data_Functor.map(Effect_Aff.functorAff);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var forever = /* #__PURE__ */ Control_Monad_Rec_Class.forever(Effect_Aff.monadRecAff);
var isObservableLikeSubject = {
    toObservable: Unsafe_Coerce.unsafeCoerce
};
var isSubjectLikeSubject = {
    toSubject: identity,
    IsObservableLike0: function () {
        return isObservableLikeSubject;
    }
};
var isObservableLikeReplaySub = {
    toObservable: Unsafe_Coerce.unsafeCoerce
};
var isSubjectLikeReplaySubjec = {
    toSubject: Unsafe_Coerce.unsafeCoerce,
    IsObservableLike0: function () {
        return isObservableLikeReplaySub;
    }
};
var isObservableLikeObservabl = {
    toObservable: identity
};
var unsubscribe = /* #__PURE__ */ Effect_Uncurried.runEffectFn1($foreign.unsubscribeImpl);
var toSubject = function (dict) {
    return dict.toSubject;
};
var toObservable = function (dict) {
    return dict.toObservable;
};
var toArray = function (dictIsObservableLike) {
    var toObservable1 = toObservable(dictIsObservableLike);
    return function (o) {
        return $foreign.toArrayImpl(toObservable1(o));
    };
};
var timeout = function (dictIsObservableLike) {
    var toObservable1 = toObservable(dictIsObservableLike);
    return function (duration) {
        return function (observable) {
            return $foreign.timeoutImpl(duration)(toObservable1(observable));
        };
    };
};
var throwError = function (err) {
    return $foreign.throwErrorImpl(function (v) {
        return err;
    });
};
var takeWhile = function (dictIsObservableLike) {
    var toObservable1 = toObservable(dictIsObservableLike);
    return function (f) {
        return function (o) {
            return $foreign.takeWhileImpl(f, false)(toObservable1(o));
        };
    };
};
var takeUntil = function (dictIsObservableLike) {
    var toObservable1 = toObservable(dictIsObservableLike);
    return function (dictIsObservableLike1) {
        var toObservable2 = toObservable(dictIsObservableLike1);
        return function (notifier) {
            return function (o) {
                return $foreign.takeUntilImpl(toObservable2(notifier))(toObservable1(o));
            };
        };
    };
};
var take = function (dictIsObservableLike) {
    var toObservable1 = toObservable(dictIsObservableLike);
    return function (count) {
        return function (o) {
            return $foreign.takeImpl(count)(toObservable1(o));
        };
    };
};
var subscribe = function (dictIsObservableLike) {
    var toObservable1 = toObservable(dictIsObservableLike);
    return function (handlers) {
        return function (observable) {
            return function () {
                return $foreign.subscribeImpl({
                    next: Effect_Uncurried.mkEffectFn1(handlers.next),
                    error: Effect_Uncurried.mkEffectFn1(handlers.error),
                    complete: handlers.complete
                }, toObservable1(observable));
            };
        };
    };
};
var subscribe1 = /* #__PURE__ */ subscribe(isObservableLikeObservabl);
var subscribeAff = function (dictMonadEffect) {
    var liftEffect1 = Effect_Class.liftEffect(dictMonadEffect);
    return function (observable) {
        return liftEffect1(function __do() {
            var avar = Effect_AVar.empty();
            var handleElement = function (elem) {
                return Effect_Aff.launchAff_(bind1($$try(Effect_Aff_AVar.put(elem)(avar)))(function () {
                    return pure(Data_Unit.unit);
                }));
            };
            var subscription = subscribe1({
                next: function (elem) {
                    return handleElement(new Fusion_Data_ObservableEvent.OnNext(elem));
                },
                error: function (err) {
                    return handleElement(new Fusion_Data_ObservableEvent.OnError(err));
                },
                complete: handleElement(Fusion_Data_ObservableEvent.OnComplete.value)
            })(observable)();
            return {
                next: Effect_Aff_AVar.take(avar),
                cancel: liftEffect(unsubscribe(subscription))
            };
        });
    };
};
var subscribeValues = function (dictIsObservableLike) {
    var toObservable1 = toObservable(dictIsObservableLike);
    return function (next_) {
        return function (observable) {
            return subscribe1({
                next: next_,
                error: function (v) {
                    return pure1(Data_Unit.unit);
                },
                complete: pure1(Data_Unit.unit)
            })(toObservable1(observable));
        };
    };
};
var toHyrule = function (dictIsObservableLike) {
    var subscribe2 = subscribe(dictIsObservableLike);
    return function (rxjs) {
        return FRP_Event.makeEvent(function (emit) {
            return function __do() {
                var subscription = subscribe2({
                    next: function ($104) {
                        return emit(Fusion_Data_ObservableEvent.OnNext.create($104));
                    },
                    error: function ($105) {
                        return emit(Fusion_Data_ObservableEvent.OnError.create($105));
                    },
                    complete: emit(Fusion_Data_ObservableEvent.OnComplete.value)
                })(rxjs)();
                return unsubscribe(subscription);
            };
        });
    };
};
var toHyruleOnlyValues = function (dictIsObservableLike) {
    var $106 = filterMap(function (v) {
        if (v instanceof Fusion_Data_ObservableEvent.OnNext) {
            return new Data_Maybe.Just(v.value0);
        };
        return Data_Maybe.Nothing.value;
    });
    var $107 = toHyrule(dictIsObservableLike);
    return function ($108) {
        return $106($107($108));
    };
};
var skip = function (dictIsObservableLike) {
    var toObservable1 = toObservable(dictIsObservableLike);
    return function (count) {
        return function (o) {
            return $foreign.skipImpl(count)(toObservable1(o));
        };
    };
};
var shareReplay = function (dictIsObservableLike) {
    var toObservable1 = toObservable(dictIsObservableLike);
    return function (o) {
        return function () {
            return $foreign.shareReplayImpl(toObservable1(o));
        };
    };
};
var promiseToAff = function (promise) {
    return Data_Function.flip(catchError1)(function (err) {
        return pure(new Data_Maybe.Just(new Data_Either.Left(err)));
    })(map1(map2(Data_Either.Right.create))(bind1(liftEffect(promise))(Control_Promise["toAff$prime"](Foreign.unsafeFromForeign))));
};
var next = function (dictIsSubjectLike) {
    var toSubject1 = toSubject(dictIsSubjectLike);
    return function (subjectLike) {
        return Effect_Uncurried.runEffectFn2($foreign.nextImpl)(toSubject1(subjectLike));
    };
};
var mkReplaySubject = $foreign.mkReplaySubjectImpl;
var mkObservable = function (create) {
    return $foreign.mkObservableImpl(function (handlers) {
        return create({
            next: Effect_Uncurried.runEffectFn1(handlers.next),
            error: Effect_Uncurried.runEffectFn1(handlers.error),
            complete: handlers.complete
        })();
    });
};
var mkObservableAff = function (action) {
    return mkObservable(function (subscription) {
        return function __do() {
            var avar = Effect_AVar.empty();
            var fiberTake = Effect_Aff.launchAff(forever(bind1(Effect_Aff_AVar.take(avar))(function (elem) {
                if (elem instanceof Fusion_Data_ObservableEvent.OnNext) {
                    return liftEffect(subscription.next(elem.value0));
                };
                if (elem instanceof Fusion_Data_ObservableEvent.OnError) {
                    return liftEffect(subscription.error(elem.value0));
                };
                if (elem instanceof Fusion_Data_ObservableEvent.OnComplete) {
                    return liftEffect(subscription.complete);
                };
                throw new Error("Failed pattern match at Fusion.Foreign.Rx (line 573, column 7 - line 576, column 57): " + [ elem.constructor.name ]);
            })))();
            var fiberPut = Effect_Aff.launchAff(Data_Function.flip(Effect_Aff["finally"])(action(function (a) {
                return Effect_Aff_AVar.put(a)(avar);
            }))(Effect_Aff.killFiber(Fusion_Generator.cancellationException)(fiberTake)))();
            var unsubscriber = Effect_Aff.launchAff_(Effect_Aff.killFiber(Fusion_Generator.cancellationException)(fiberPut));
            return unsubscriber;
        };
    });
};
var mapWithIndex = function (dictIsObservableLike) {
    var toObservable1 = toObservable(dictIsObservableLike);
    return function (f) {
        return function (o) {
            return $foreign.mapImpl(Data_Function_Uncurried.mkFn2(f))(toObservable1(o));
        };
    };
};
var map = function (dictIsObservableLike) {
    var mapWithIndex1 = mapWithIndex(dictIsObservableLike);
    return function (f) {
        return mapWithIndex1(function (x) {
            return function (v) {
                return f(x);
            };
        });
    };
};
var functorObservable = {
    map: /* #__PURE__ */ map(isObservableLikeObservabl)
};
var lastValueFrom = function (dictIsObservableLike) {
    var map3 = map(dictIsObservableLike);
    return function (observable) {
        return promiseToAff((function (s) {
            return function () {
                return $foreign.lastValueFromImpl(s, Data_Maybe.Nothing.value);
            };
        })(map3(Data_Maybe.Just.create)(observable)));
    };
};
var lastValueFrom1 = /* #__PURE__ */ lastValueFrom(isObservableLikeObservabl);
var onComplete = function (dictIsObservableLike) {
    var $109 = map1(function (v) {
        if (v instanceof Data_Maybe.Just && v.value0 instanceof Data_Either.Left) {
            return new Data_Either.Left(v.value0.value0);
        };
        return new Data_Either.Right(Data_Unit.unit);
    });
    var $110 = lastValueFrom(dictIsObservableLike);
    return function ($111) {
        return $109($110($111));
    };
};
var inclusiveTakeWhile = function (dictIsObservableLike) {
    var toObservable1 = toObservable(dictIsObservableLike);
    return function (f) {
        return function (o) {
            return $foreign.takeWhileImpl(f, true)(toObservable1(o));
        };
    };
};
var fromHyrule = function (hyrule) {
    return mkObservable(function (handlers) {
        return FRP_Event.subscribe(hyrule)(function (v) {
            if (v instanceof Fusion_Data_ObservableEvent.OnNext) {
                return handlers.next(v.value0);
            };
            if (v instanceof Fusion_Data_ObservableEvent.OnError) {
                return handlers.error(v.value0);
            };
            if (v instanceof Fusion_Data_ObservableEvent.OnComplete) {
                return handlers.complete;
            };
            throw new Error("Failed pattern match at Fusion.Foreign.Rx (line 521, column 22 - line 524, column 36): " + [ v.constructor.name ]);
        });
    });
};
var fromArray = $foreign.ofImpl;
var firstValueFrom = function (dictIsObservableLike) {
    var map3 = map(dictIsObservableLike);
    return function (observable) {
        return promiseToAff((function (s) {
            return function () {
                return $foreign.firstValueFromImpl(s, Data_Maybe.Nothing.value);
            };
        })(map3(Data_Maybe.Just.create)(observable)));
    };
};
var filterWithIndex = function (dictIsObservableLike) {
    var toObservable1 = toObservable(dictIsObservableLike);
    return function (f) {
        return function (o) {
            return $foreign.filterImpl(Data_Function_Uncurried.mkFn2(f))(toObservable1(o));
        };
    };
};
var filter = function (dictIsObservableLike) {
    var filterWithIndex1 = filterWithIndex(dictIsObservableLike);
    return function (f) {
        return filterWithIndex1(function (x) {
            return function (v) {
                return f(x);
            };
        });
    };
};
var error = function (dictIsSubjectLike) {
    var toSubject1 = toSubject(dictIsSubjectLike);
    return function (subjectLike) {
        return Effect_Uncurried.runEffectFn2($foreign.errorImpl)(toSubject1(subjectLike));
    };
};
var embedEffect = function (dictIsObservableLike) {
    var subscribe2 = subscribe(dictIsObservableLike);
    return function (make) {
        return mkObservable(function (handlers) {
            return function __do() {
                var self = make();
                var subscription = subscribe2(handlers)(self)();
                return unsubscribe(subscription);
            };
        });
    };
};
var effectfulConcatMap = function (dictIsObservableLike) {
    var toObservable1 = toObservable(dictIsObservableLike);
    return function (f) {
        return function (o) {
            return $foreign.concatMapImpl(Effect_Uncurried.mkEffectFn1(f))(toObservable1(o));
        };
    };
};
var concatMap = function (dictIsObservableLike) {
    var effectfulConcatMap1 = effectfulConcatMap(dictIsObservableLike);
    return function (f) {
        return effectfulConcatMap1(function ($112) {
            return pure1(f($112));
        });
    };
};
var complete = function (dictIsSubjectLike) {
    var toSubject1 = toSubject(dictIsSubjectLike);
    return function (subjectLike) {
        return function () {
            return $foreign.completeImpl(toSubject1(subjectLike));
        };
    };
};
var collect = function (dictIsObservableLike) {
    var $113 = map1(Data_Maybe.fromMaybe(new Data_Either.Right([  ])));
    var $114 = toArray(dictIsObservableLike);
    return function ($115) {
        return $113(lastValueFrom1($114($115)));
    };
};
var catchError = function (dictIsObservableLike) {
    var toObservable1 = toObservable(dictIsObservableLike);
    return function (f) {
        return function (observable) {
            return $foreign.catchErrorImpl(Data_Function_Uncurried.mkFn2(f))(toObservable1(observable));
        };
    };
};
var mapError = function (dictIsObservableLike) {
    var catchError2 = catchError(dictIsObservableLike);
    return function (f) {
        return catchError2(function (err) {
            return function (v) {
                return throwError(f(err));
            };
        });
    };
};
export {
    catchError,
    collect,
    complete,
    concatMap,
    effectfulConcatMap,
    embedEffect,
    error,
    filter,
    filterWithIndex,
    firstValueFrom,
    fromArray,
    fromHyrule,
    inclusiveTakeWhile,
    lastValueFrom,
    map,
    mapError,
    mapWithIndex,
    mkObservable,
    mkObservableAff,
    mkReplaySubject,
    next,
    onComplete,
    shareReplay,
    skip,
    subscribe,
    subscribeAff,
    subscribeValues,
    take,
    takeUntil,
    takeWhile,
    throwError,
    timeout,
    toArray,
    toHyrule,
    toHyruleOnlyValues,
    toObservable,
    toSubject,
    unsubscribe,
    isObservableLikeObservabl,
    isObservableLikeSubject,
    isSubjectLikeSubject,
    isObservableLikeReplaySub,
    isSubjectLikeReplaySubjec,
    functorObservable
};
export {
    OnComplete,
    OnError,
    OnNext
} from "../Fusion.Data.ObservableEvent/index.js";
